/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsGetAccountApiV1LedgersLedgerCanisterIdAccountsIdGet } from "../../funcs/accountsGetAccountApiV1LedgersLedgerCanisterIdAccountsIdGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetAccountApiV1LedgersLedgerCanisterIdAccountsIdGetRequest$inboundSchema,
};

export const tool$accountsGetAccountApiV1LedgersLedgerCanisterIdAccountsIdGet:
  ToolDefinition<typeof args> = {
    name: "account-get-v1",
    description: `Original tool name: accounts-get-account-api-v1-ledgers-ledger-canister-id-accounts-id-get

Get owner's account

This endpoint returns a singular account that can be found for a given
ledger canister.

### How is data retrieved for this endpoint?

Values from the endpoint are created by the retrieved transactions from the
ledger canister. As transactions come in, the API updates the account information
and balances in the database.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await accountsGetAccountApiV1LedgersLedgerCanisterIdAccountsIdGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };